import { linearish as o } from "./linear.js";
import u from "./number.js";
function i(t) {
  var e;
  function n(r) {
    return r == null || isNaN(r = +r) ? e : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (t = Array.from(r, u), n) : t.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (e = r, n) : e;
  }, n.copy = function() {
    return i(t).unknown(e);
  }, t = arguments.length ? Array.from(t, u) : [0, 1], o(n);
}
export {
  i as default
};
